<template>
	<section class="prefooter">
		<div v-if="prefooter?.text" class="prefooter-text">
			<div class="container">
				<div class="heading">
					<RichText v-if="prefooter?.text" :content="prefooter.text.content" />
				</div>
				<Button v-if="prefooter?.cta" :data="prefooter?.cta?.fields"/>
			</div>
		</div>
	</section>
</template>

<script setup>
const  { data } = defineProps({
	data: {
		type: Object,
		required: true
	}
});

const prefooter = computed(() => data?.data ?? {});
</script>

<style lang="scss">
@use '~/assets/scss/components/Prefooter.scss';
</style>